import './square-action-box.scss';

import React from 'react';

const SquareActionBox = ({
  tabIndex,
  IconComponent,
  label,
  onClick,
  extraCssClass,
}: {
  tabIndex?: number,
  IconComponent: React.ElementType<{
    className?: string;
  }>;
  label: string | undefined;
  description?: string;
  onClick?: () => void;
  extraCssClass?: string;
}) => {
  return (
    <button className={`action-box ${extraCssClass || ''}`} onClick={onClick} tabIndex={tabIndex}>
      <IconComponent aria-hidden={true} className='action-icon' />
      <div className='action-label'>{label}</div>
    </button>
  );
};

export default SquareActionBox;
